import { render, staticRenderFns } from "./shopgroup.vue?vue&type=template&id=1a09554e&scoped=true&"
import script from "./shopgroup.vue?vue&type=script&lang=js&"
export * from "./shopgroup.vue?vue&type=script&lang=js&"
import style0 from "./shopgroup.vue?vue&type=style&index=0&id=1a09554e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a09554e",
  null
  
)

export default component.exports